import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const StatListItem = props => {
  return (
    <div className="stat-list__item" key={props.index} style={props.styles}>
      <span className="stat-list__item-stat-name">{props.name}</span>
      <span className="stat-list__item-stat-rating">{props.value}</span>
    </div>
  );
};

StatListItem.propTypes = {
  styles: PropTypes.object,
  name: PropTypes.string,
  value: PropTypes.string,
};

export default StatListItem;
